import LogRocket from 'logrocket'
import LogRocketReact from 'logrocket-react'
import { Observable, of } from 'rxjs'
import Member from 'iam/models/Member'
import { Env } from 'infra/env'
import { tap, switchMap, share } from 'rxjs/operators'
import { Id } from 'types/definitions'

/**
 * LogRocket integration.
 */
export function LogRocketIntegration(
  currentMember$: Observable<Member>,
): Observable<unknown> {
  return of(null).pipe(
    // Ensures we don't init until we subscribe.
    tap(() => {
      LogRocket.init(Env.LOGROCKET_KEY, {
        release: `Work Portal v${process.env.__VERSION__}`,
        network: {
          requestSanitizer: scrubReqRes,
          responseSanitizer: scrubReqRes,
        },
      })
      LogRocketReact(LogRocket)
    }),
    switchMap(() => currentMember$),
    tap((member) => {
      const identity = {
        first_name: member.givenName,
        last_name: member.familyName,
        name: member.displayName,
        email: member.email,
        workspace_id: Id.assert(member.workspace.id),
      }

      LogRocket.identify(Id.assert(member.user.id), identity)
    }),
    share(),
  )
}

/**
 * Scrubs request/response objects.
 *
 * @param obj
 */
function scrubReqRes(obj: any) {
  // Scrub all messages req/res.
  if (obj.url.includes('/messages')) {
    obj.body = '[Redacted]'
  }

  if (obj.url.includes('__authorization')) {
    return null
  }

  return obj
}
